export const SCHEDULED_DELIVERY_REGISTER_FILE_NAME = "ScheduledDelivery";
